export const OfficeCustomEquipmentUpdateState = {
	url: '/custom-equipment-update/:series_id',
	title: 'Office Custom Equipment - Update',
	template: '<custom-equipment-update-page></custom-equipment-update-page>',
	params: {series_id: null, label: null},
	lazyLoad: $transition$ => {
		const $ocLazyLoad = $transition$.injector().get('$ocLazyLoad');
		const $log = $transition$.injector().get('$log');
		return import(
			/* webpackChunkName: "officeCustomEquipUpdatePageMod" */
			'@Containers/office-custom-equipment-page/office-custom-equipment-update.cmp.js'
		)
			.then(res => $ocLazyLoad.load({name: res.default}))
			.catch(err => $log.error(err));
	},
};
